import produce from 'immer'
import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import { createNamespacedReducer } from '../namespaces'
import {
  fetchResponse,
  mitreAttackResponse
} from './actions'

const fetched = handleActions({
  [fetchResponse]: createNamespacedReducer((state, action) => {
    if (action.error) {
      console.error(action.payload)
      if (action.payload && action.payload.message === '403') {
        return '403'
      } else {
        return null
      }
    }

    return action.payload
  })
}, {})

const mitreAttackStore = handleActions({
  [mitreAttackResponse]: produce((draft, action) => {
    const { ids, data, error } = action.payload
    if (error) {
      console.error(error.message)
      return
    }
    const patterns = []
    const obj = ids.length > 0 ? { id: ids[0], data } : []
    return {
      mitreAttack: {
        patterns: patterns.concat(obj)
      }
    }
  }),
}, [])

export * from './actions'
export * from './hooks'
export * from './normalizers'
export * from './selectors'

export default combineReducers({
  fetched,
  mitreAttackStore
})
